import { useEffect, useState } from 'react';
import {
    useFloating,
    useInteractions,
    useRole,
    FloatingPortal,
    FloatingOverlay,
    FloatingFocusManager,
} from '@floating-ui/react';
import { motion, AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import useFloatingProps from 'Hooks/useFloatingProps';

const Overlay = motion(FloatingOverlay);

const DELAY_SHOW_DIALOG = 3000;

export default function DialogWithDelay(props) {
    const { children } = useFloatingProps(props);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpen(true);
        }, DELAY_SHOW_DIALOG);

        return () => clearTimeout(timer);
    }, []);

    const { refs, context } = useFloating({
        open,
    });

    const { getFloatingProps } = useInteractions([useRole(context, { role: 'dialog' })]);

    return (
        <FloatingPortal>
            <AnimatePresence initial={false}>
                {open && (
                    <Overlay
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0, transition: { delay: 0.3 } }}
                        lockScroll
                        className="flex flex-col overflow-auto bg-black/35 p-6 backdrop-blur-[1.5px]"
                        style={{ zIndex: 'var(--z-index-modal)' }}
                    >
                        <FloatingFocusManager context={context}>
                            <motion.div
                                initial={{ opacity: 0, y: -28 }}
                                animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
                                exit={{ opacity: 0, y: -28 }}
                                {...getFloatingProps({
                                    ref: refs.setFloating,
                                    className:
                                        'relative m-auto w-full max-w-[640px] rounded-lg bg-white md:rounded-3xl',
                                })}
                            >
                                <div className="p-5 md:px-[18%] md:py-6">{children}</div>
                            </motion.div>
                        </FloatingFocusManager>
                    </Overlay>
                )}

                {!open && <div className="fixed inset-0" style={{ zIndex: 'var(--z-index-modal)' }} />}
            </AnimatePresence>
        </FloatingPortal>
    );
}

DialogWithDelay.propTypes = {
    children: PropTypes.node.isRequired,
};
